const defaults = {
    // If the image gets within 50px in the Y axis, start the download.
    rootMargin: '-50px 0px',
    threshold: 0.02
};

let observer;
let entriesCount = 0;

function onIntersection(entries) {
    // console.log('onIntersection', entries);

    // console.log('onIntersection', 'loop');

    // Loop through the entries
    for (let i = 0; i < entries.length; i++) {
        let entry = entries[i];
        // console.log('onIntersection', entry);
        // Are we in viewport?
        if (entry.intersectionRatio > 0) {
            entriesCount--;

            // console.log('unobserve', entry);

            // Stop watching
            observer.unobserve(entry.target);

            let id = entry.target.getAttribute('data-product-id');
            // let url = entry.target.getAttribute('data-product-url');

            if (id) {
                DLHelper.measureProductImpressions(id, currencyCode);
            }
        }
    }

    // Disconnect if we've already loaded all of the images
    if (entriesCount === 0) {
        // console.log('onIntersection', 'disconnect');
        disconnect();
    }
}

/**
 * Disconnect the observer
 */
function disconnect() {
    if (!observer) {
        return;
    }

    observer.disconnect();
}

let AnalyticsHelper = {
    init: (options) => {
        if (!('IntersectionObserver' in window)) {
            return;
        }
        let config = {...defaults, ...options};
        observer = new IntersectionObserver(onIntersection, config);

        let products = document.querySelectorAll(`.product`);
        entriesCount = products.length;

        products.forEach(productElement => {
            let price = productElement.querySelector(`.price`);
            if (price) {
                observer.observe(price);
            }
        })
    }
};

export default AnalyticsHelper;